import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <UpdatesSection />
        <FeaturesSection />
        <CardsSection />
        <FaqSection />
        <MediaSection />
        <RankingSection />
        <TopicsSection />
        <ContactSection />
        <CarouselSection />
        <AppSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}